import Swal from 'sweetalert2';
import { history } from '../store';
import ReactDOMServer from 'react-dom/server';

const swal = {
  success: (text, redirect, refresh = false) => {
    Swal.fire({
      title: 'Sucesso!',
      text,
      icon: 'success',
      timer: 3000,
      showConfirmButton: false,
      timerProgressBar: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer && redirect) {
        if (refresh) {
          history.push('/refresh');
        }
        history.push(redirect);
      }
    });
  },
  error: (text) => {
    Swal.fire({
      title: 'Ops!',
      html: text,
      icon: 'error',
      confirmButtonText: 'Tentar Novamente',
    });
  },
  warning: (message = "") => {
    Swal.fire({
      title: 'Ops!',
      text: message,
      icon: 'warning',
      showConfirmButton: false,
      showCancelButton: false,
      timer: 3000,
    })
  },
  user: async() => {
    return await Swal.fire({
      title: 'USUÁRIO JÁ LOGADO!',
      html: `Deseja logar assim mesmo?<br/>
      Isso fará com que sua outra sessão seja encerrada`,
      icon: 'error',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      showCancelButton: true,
    });
  },
  session_expired: async() => {
    return await Swal.fire({
      title: 'SESSÃO EXPIRADA!',
      html: `Faça login novamente`,
      icon: 'error',
      confirmButtonText: 'OK',
    });
  },
  message: async (title, element) => {
    let text = ReactDOMServer.renderToString(element);

    return await Swal.fire({
      title: title,
      html: text,
      // showCancelButton: true,
      // confirmButtonText: 'Continuar',
      // cancelButtoText: 'Cancelar',
    });
    
    // if (result.isConfirmed) {
    //   Swal.fire('Saved!', '', 'success')
    // } else if (result.isDenied) {
    //   Swal.fire('Changes are not saved', '', 'info')
    // }
    // ;
  },
  adhesionWarning: async (msg, type, title, html = null) => {
    return await Swal.fire({
      html,
      icon: type,
      title: title,
      text: msg,
      width: 800,
      allowOutsideClick: false,
      allowEscapeKey: false,
      padding: '3em',
      color: '#716add',
      backdrop: `
        rgba(245, 121, 33, 1)
        left top
        no-repeat
      `,
      confirmButtonText: "Sair"
    });
  },
  fiscalYearSelection: async () => {
    return await Swal.fire({
      html: `
        <div class='d-flex'>
          <div class='row'>
            teste
          </div>
        </div>
      `,
      title: "Selecione o Ano Fiscal",
      width: 800,
      allowOutsideClick: false,
      allowEscapeKey: false,
      padding: '3em',
      color: '#716add',
      backdrop: `
        rgba(245, 121, 33, 1)
        left top
        no-repeat
      `,
      confirmButtonText: "Sair"
    });
  }
};

export default swal;
